function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { WDHComponent } from '../../../../wdh-foundation/wdh';
/**
 * @memberOf module:wdh-geo-ip-prompt
 */

var WDHGeoIpPrompt = /*#__PURE__*/function (_WDHComponent) {
  _inherits(WDHGeoIpPrompt, _WDHComponent);

  var _super = _createSuper(WDHGeoIpPrompt);

  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHGeoIpPrompt() {
    var _this;

    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'geo-ip-prompt';

    _classCallCheck(this, WDHGeoIpPrompt);

    _this = _super.call(this, className);
    /**
     * Sets the z-index for the pop-up, which should be high enough for it to overlay everything else on the page.
     * @type {number}
     * @default 1000
     */

    _this.zIndex = 1000;
    /**
     * Decides wether the "x" button will be created on the pop-up. This button will dismiss the pop-up when clicked.
     * @type {boolean}
     * @default true
     */

    _this.showDismissButton = true;
    /**
     * Decides wether the user can dismiss the pop-up when he clicks outside the pop-up dialog box.
     * @type {boolean}
     * @default true
     */

    _this.dismissOnClickOutsidePopup = true;
    /**
     * Avoids redirecting from subpage back to main page after cookie is accepted
     * @type {boolean}
     * @default false
     */

    _this.goToCountrySubPage = false;
    /**
     * The name of the cookie that is set when the prompt is dismissed.
     * @type {string}
     * @default 'geo_ip_prompt_dismissed'
     */

    _this.cookieName = 'geo_ip_prompt_dismissed';
    return _this;
  }

  _createClass(WDHGeoIpPrompt, [{
    key: "init",
    value: function init(component) {
      if (!this.isDismissed() && this.hasContent(component)) {
        component.classList.add('show');

        if (this.dismissOnClickOutsidePopup) {
          this.setComponentClickListener(component);
        }

        if (this.showDismissButton) {
          this.createDismissButton(component);
        }

        if (this.goToCountrySubPage) {
          this.decorateCountryHref(component);
        }

        this.setStayButtonClickListener(component);
        this.setZIndex(component);
      }
    }
  }, {
    key: "isDismissed",
    value: function isDismissed() {
      return window.DGS.Cookies.getInstance().readCookie(this.cookieName) != null;
    }
  }, {
    key: "hasContent",
    value: function hasContent(component) {
      var contentChildren = _toConsumableArray(component.firstElementChild.children);

      var hasContent = false;
      contentChildren.forEach(function (child) {
        if (child.children.length > 0 && child.innerHTML !== '<a href="#"></a>') {
          hasContent = true;
        }
      });
      return hasContent;
    }
  }, {
    key: "setComponentClickListener",
    value: function setComponentClickListener(component) {
      var _this2 = this;

      component.addEventListener('click', function (e) {
        _this2.onComponentClick(e, component);
      });
    }
  }, {
    key: "onComponentClick",
    value: function onComponentClick(e, component) {
      if (e.target === component) {
        this.dismiss(component);
      }
    }
  }, {
    key: "dismiss",
    value: function dismiss(component) {
      component.classList.remove('show');
      window.DGS.Cookies.getInstance().createCookie(this.cookieName, 1, 30);
    }
  }, {
    key: "createDismissButton",
    value: function createDismissButton(component) {
      var _this3 = this;

      var dismissButton = document.createElement('div');
      var componentContent = component.getElementsByClassName('component-content')[0];
      dismissButton.classList.add('geo-ip-prompt-dismiss');
      dismissButton.textContent = 'x';
      dismissButton.addEventListener('click', function () {
        _this3.onDismissClick(component);
      });
      componentContent.insertBefore(dismissButton, componentContent.firstChild);
    }
  }, {
    key: "decorateCountryHref",
    value: function decorateCountryHref(component) {
      var link = component.querySelector('.geo-ip-prompt-countryspecificsite a');
      var newHref = link.href;
      var pathname = window.location.pathname;

      if (newHref.substr(-1) === '/') {
        newHref = newHref.substr(0, newHref.length - 1);
      }

      if (pathname.substr(0, 1) === '/') {
        pathname = pathname.substr(1);
      }

      link.href = newHref + '/' + pathname;
    }
  }, {
    key: "onDismissClick",
    value: function onDismissClick(component) {
      this.dismiss(component);
    }
  }, {
    key: "setStayButtonClickListener",
    value: function setStayButtonClickListener(component) {
      var _this4 = this;

      var stayButton = component.querySelector('.geo-ip-prompt-currentsite a');
      stayButton.href = ''; // Removes the # from href to keep the site from scrolling. This is related to the hacky solution of anchor handling in dgs-api

      stayButton.addEventListener('click', function (event) {
        event.preventDefault();

        _this4.onDismissClick(component);
      });
    }
  }, {
    key: "setZIndex",
    value: function setZIndex(component) {
      component.style.zIndex = this.zIndex;
    }
  }]);

  return WDHGeoIpPrompt;
}(WDHComponent);

export default WDHGeoIpPrompt;